export function parseInvoiceLineAmount(value: string | number): number | null {
  const text = `${value}`.trim();
  if (!text) {
    return null;
  }

  const amount = Number(text);
  return Number.isFinite(amount) && amount >= 0 ? amount : null;
}
